import { render, staticRenderFns } from "./HistoricoInativacao.vue?vue&type=template&id=f44ea898&"
import script from "./HistoricoInativacao.vue?vue&type=script&lang=js&"
export * from "./HistoricoInativacao.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoInativacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports